<div class="container single-view" id="add-card-order">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/card-orders/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CARD_ORDERS.BTN_BACK_TO_CARD_ORDER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-card-order-title"  class="section-title">{{ 'CARD_ORDER_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-card-order-subtitle"  class="section-subtitle mt-1 text-base">{{ 'CARD_ORDER_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="cardOrderingForm">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-card-order-details" class="border-b pb-3">{{ 'CARD_ORDER_CREATE.CARD_ORDER_DETAILS' | translate }}</h2>
                </div>

                <div class="field-wr flex flex-col col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                  <label
                    data-testid="add-card-order-shipping-retailer-label"
                    class="block text-sm"
                    for="originRetailer">
                    {{ 'CARD_ORDER_CREATE.SHIPPING_RETAILER' | translate }}
                    <i class="icon-required-field"></i>
                  </label>

                  <app-custom-dropdown
                    data-testid="shipping-retailer"
                    [placeholder]="'CARD_ORDER_CREATE.PLACEHOLDER_SELECT_RETAILER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['retailers'].rowsPerPageOption || 5"
                    [totalCount]="combosData['retailers'].totalRecords"
                    [totalPages]="getComboTotalPages('retailers')"
                    [options]="combosData['retailers'].list"
                    formControlName="originRetailer"
                    (onLazyLoad)="onLazyLoadComboData('retailers', $event)">
                  </app-custom-dropdown>
                </div>
              </div>

              <div formArrayName="destinations">
                <div class="flex flex-col col-12 mb-4">
                  <h3 data-testid="add-card-order-destination-retailer-label" class="mt-0 mb-0">{{ 'CARD_ORDER_CREATE.DESTINATION_RETAILERS' | translate }}</h3>
                </div>

                <div class="field-wr flex flex-col col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                  <button data-testid="add-card-order-add-destination-retailer" class="btn outline-btn"
                    [disabled]="cardOrderingForm.get('originRetailer')?.invalid" (click)="addDestinationRetailer()">
                    {{ 'CARD_ORDER_CREATE.BTN_ADD_DESTINATION_RETAILERS' | translate }}
                  </button>
                </div>
                @if (!destinations.controls.length) {
                  <div class="field-wr flex flex-col col-12">
                    <p>{{ 'CARD_ORDER_CREATE.ADD_RETAILER_SERIAL_NUMBERS_TO_ORDER' | translate }}</p>
                  </div>
                }

                @for (destination of destinations.controls; track destination; let i = $index) {
                  <div [formGroupName]="i"
                    class="row rounded-card mt-4" [attr.data-testid]="'destination-' + i">
                    <div class="flex flex-col col-12 mb-2">
                      <div class="flex items-center">
                        <h4 data-testid="add-card-order-create-destination-retailer">{{ 'CARD_ORDER_CREATE.DESTINATION_RETAILER' | translate }} <span class="destination-counter">#{{i + 1}}</span></h4>
                        <button data-testid="add-card-order-add-destination-retailer-btn" class="btn borderless-btn btn-icon icon-trash" pTooltip="{{ 'CARD_ORDER_CREATE.BTN_REMOVE_DESTINATION' | translate }}" tooltipPosition="top"  (click)="removeDestination(i)"></button>
                      </div>
                    </div>
                    <div class="field-wr flex flex-col col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                      <label data-testid="add-card-order-retailer-label" class="block text-sm" [for]="'destination-retailer-' + i">
                        {{ 'CARD_ORDER_CREATE.RETAILER' | translate }} <i class="icon-required-field"></i>
                      </label>
                      <app-custom-dropdown
                        [data-testid]="'destination-retailer-' + i"
                        [placeholder]="'CARD_ORDER_CREATE.PLACEHOLDER_SELECT_RETAILER' | translate"
                        optionLabel="text"
                        optionValue="id"
                        [isMultiselect]="false"
                        [showSelectionChips]="true"
                        [showClear]="false"
                        [searchMode]="'remote'"
                        [pageSize]="destinationStoresRowsPerPageOption"
                        [totalCount]="getDestinationStoresTotalRecords(i)"
                        [totalPages]="getDestinationStoresTotalPages(i)"
                        [options]="getStoresList(i)"
                        formControlName="destinationRetailer"
                        (onLazyLoad)="onLazyLoadDestinationStores($event, i)">
                      </app-custom-dropdown>
                      @if (destination.get('destinationRetailer')?.touched && destination.get('destinationRetailer')?.invalid) {
                        @if (destination.get('destinationRetailer')?.hasError('required')) {
                          <small data-testid="retailer-mandatory" class="p-error">
                            {{ 'FORMS.MANDATORY_FIELD' | translate }}
                          </small>
                        }
                      }
                    </div>
                    @for (serialNumber of getSerialNumbersForDestination(i).controls; track serialNumber; let j = $index) {
                      <div formArrayName="serialNumbers" class="field-wr btn-field flex flex-col col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                        <label data-testid="add-card-order-serialnumber-label"  [for]="'serialNumber-' + i + '-' + j" class="block text-sm mb-2">
                          {{ 'CARD_ORDER_CREATE.SERIAL_NUMBER' | translate }} <i class="icon-required-field"></i>
                        </label>
                        <div class="flex flex-col">
                          <div class="flex gap-2">
                            <input [id]="'serialNumber-' + i + '-' + j" type="text" [formControlName]="j" autocomplete="off">
                            @if (getSerialNumbersForDestination(i).length > 1) {
                              <button data-testid="remove-btn" class="btn primary-btn remove-btn"
                                pTooltip="{{ 'CARD_ORDER_CREATE.BTN_REMOVE_SERIAL_NUMBER_ITEM' | translate }}" tooltipPosition="top"
                                (click)="removeSerialNumber(i, j)">
                                <span class="btn-label">{{ 'CARD_ORDER_CREATE.BTN_REMOVE_SERIAL_NUMBER_ITEM' | translate }}</span>
                              </button>
                            }
                            @if (j === getSerialNumbersForDestination(i).length - 1 && getSerialNumbersForDestination(i).length < limit) {
                              <button data-testid="add-btn" class="btn primary-btn add-btn" pTooltip="{{ 'CARD_ORDER_CREATE.BTN_ADD_SERIAL_NUMBER_ITEM' | translate }}"
                                tooltipPosition="top"
                                (click)="addSerialNumber(i)">
                                <span class="btn-label">{{ 'CARD_ORDER_CREATE.BTN_ADD_SERIAL_NUMBER_ITEM' | translate }}</span>
                              </button>
                            }
                          </div>
                          @if (getSerialNumbersForDestination(i).at(j).touched && getSerialNumbersForDestination(i).at(j).invalid) {
                            @if (getSerialNumbersForDestination(i).at(j).hasError('required')) {
                              <small class="p-error">
                                {{ 'FORMS.MANDATORY_FIELD' | translate }}
                              </small>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="row">
                <div class="col-12 mt-2 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-card-order-create-btn" class="btn primary-btn" [disabled]="cardOrderingForm.invalid || destinations.length === 0" (click)="submitForm()">{{ 'CARD_ORDER_CREATE.BTN_ADD_NEW_CARD_ORDER' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
